import { GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarFilterButton } from "@mui/x-data-grid-pro";
import { Button } from "antd";
import styles from "../../services/styles";

const { bc1 } = styles

export default function CustomToolbar(props) {
    return (
        <GridToolbarContainer>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', flex: 1 }}>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}>
                    {props.children}
                </div>
            </div>
        </GridToolbarContainer>
    )
}